"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDiscountLoyalty = exports.isLevelLoyalty = exports.LoyaltyEarningMode = exports.LoyaltyType = void 0;
var LoyaltyType;
(function (LoyaltyType) {
    LoyaltyType["LEVEL"] = "LEVEL";
    LoyaltyType["DISCOUNT"] = "DISCOUNT";
})(LoyaltyType || (exports.LoyaltyType = LoyaltyType = {}));
var LoyaltyEarningMode;
(function (LoyaltyEarningMode) {
    LoyaltyEarningMode["ITEM"] = "ITEM";
    LoyaltyEarningMode["EURO"] = "EURO";
})(LoyaltyEarningMode || (exports.LoyaltyEarningMode = LoyaltyEarningMode = {}));
const isLevelLoyalty = (object) => {
    return object?.type === LoyaltyType.LEVEL;
};
exports.isLevelLoyalty = isLevelLoyalty;
const isDiscountLoyalty = (object) => {
    return object?.type === LoyaltyType.DISCOUNT;
};
exports.isDiscountLoyalty = isDiscountLoyalty;
